import { MrbBaseRouteStore } from "mrb/core";
import { NakiNigunImportService, ProducerService, MediaVaultStreamService } from "common/services";
import { createBaasicAuthenticatedMediaVaultUrl } from "mrb/baasic";

class NakiNigunImportBatchPreviewRouteStore extends MrbBaseRouteStore {
    constructor(rootStore) {
        super(rootStore);

        this.service = rootStore.createApplicationService(NakiNigunImportService);
        this.producerService = rootStore.createApplicationService(ProducerService);
        this.mediaVaultStreamService = new MediaVaultStreamService(
            this.rootStore.apiClient,
            this.rootStore.application.baasic
        );
    }

    async getBatch(id) {
        const response = await this.service.get(id);
        return response.data;
    }

    async enableBatch(id) {
        const response = await this.service.enableBatch(id);
        return response.data;
    }

    async saveMetadata(id, payload) {
        const response = await this.service.saveMetadata(id, payload);
        return response.data;
    }

    async addToSystem(id) {
        const response = await this.service.addToSystem(id);
        return response.data;
    }

    async discardBatch(id) {
        const response = await this.service.discardBatch(id);
        return response.data;
    }

    async uploadArtwork(file) {
        const response = await this.service.uploadArtwork(file);
        return response.data;
    }

    async findProducers(searchPhrase) {
        const response = await this.producerService.find(searchPhrase);
        return response.data;
    }

    // The staged artwork ids exposed by the batch DTO are generic MediaVault file-entry ids (the
    // import uploads them through the generic MediaVault module, not an entity-bound cover endpoint),
    // so they must be resolved through the generic MediaVault stream route rather than the
    // naki-nigun artist/album cover stream routes.
    getMediaVaultFileUrl(id) {
        return this.mediaVaultStreamService.mediaVaultModule.streams.routeDefinition.get(id);
    }

    createStagedArtworkUrl(id, width = null, height = null) {
        if (!id) {
            return null;
        }
        return createBaasicAuthenticatedMediaVaultUrl(this.rootStore, this.getMediaVaultFileUrl(id), {
            width: width,
            height: height,
        });
    }
}

export default NakiNigunImportBatchPreviewRouteStore;
